module.exports = __webpack_public_path__ + "img/delivery_creation_info.41f4aa18.svg";